import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';
import { DollarSign } from 'lucide-react';

interface DistributionItem {
  label: string;
  amount: number;
  percentage: number;
  color: string;
}

interface ProfitDistributionPanelProps {
  totalProfit: number;
  distributions: DistributionItem[];
  period: string;
}

const ProfitDistributionPanel = ({
  totalProfit,
  distributions,
  period,
}: ProfitDistributionPanelProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">
          Profit Distribution
        </CardTitle>
        <CardDescription>For {period}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
          <div className="flex items-center gap-2">
            <DollarSign className="h-4 w-4 text-green-600" />
            <span className="text-sm text-muted-foreground">Total Profit</span>
          </div>
          <span className="text-lg font-bold text-green-600">
            ${totalProfit.toLocaleString()}
          </span>
        </div>

        <div className="space-y-3">
          {distributions.map((item, index) => (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <div
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: item.color }}
                  />
                  <span className="font-medium">{item.label}</span>
                </div>
                <div className="text-right">
                  <span className="font-semibold">
                    ${item.amount.toLocaleString()}
                  </span>
                  <span className="text-muted-foreground ml-2">
                    ({item.percentage.toFixed(1)}%)
                  </span>
                </div>
              </div>
              <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-500"
                  style={{ width: `${item.percentage}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfitDistributionPanel;
